import { useMemo } from 'react';
import useGetContextQuery from './api/useGetContextQuery';
import { getPlatform, Platform } from '@/utils/common';

interface PlatformInfo {
  platform: Platform;
  isMobile: boolean;
  isElectron: boolean;
  isBrowser: boolean;
  isLoading: boolean;
}

const usePlatform = (): PlatformInfo => {
  const { data: context, isLoading } = useGetContextQuery();

  return useMemo(() => {
    const platform = getPlatform(context?.mode);

    return {
      platform,
      isMobile: platform === 'mobile',
      isElectron: platform === 'electron',
      isBrowser: platform === 'browser',
      isLoading,
    };
  }, [context?.mode, isLoading]);
};

export default usePlatform;
